"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

/* eslint-disable no-useless-escape */
var validEmail = function validEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
};

var validDate = function validDate(date) {
  // eslint-disable-next-line
  return !isNaN(Date.parse(date));
};

var validCustom = function validCustom(customValue, customRegEx) {
  return customRegEx.test(customValue);
};

var useFormElementValidation = function useFormElementValidation(initialValue, options) {
  var _useState = (0, _react.useState)(initialValue),
      setValue = _useState[1];

  var _useState2 = (0, _react.useState)({}),
      errors = _useState2[0],
      setErrors = _useState2[1]; // useEffect(() => setValue(initialValue), [initialValue]);


  var checkErrors = function checkErrors(valueToTest) {
    var newErrors = [];

    if (options.required && (!valueToTest || valueToTest && valueToTest.length === 0)) {
      newErrors.push('This field is required');
    }

    if (options.required && options.currency && valueToTest && +valueToTest === 0) {
      newErrors.push('This field cannot be 0');
    }

    if (options.date && valueToTest && !validDate(valueToTest)) {
      newErrors.push('Please enter a valid date');
    }

    if (options.email && valueToTest && !validEmail(valueToTest)) {
      newErrors.push('Please enter a valid email');
    }

    if (options.number && valueToTest && options.max < +valueToTest) {
      newErrors.push(options.customMessage || "Too much, max " + options.max);
    }

    if (options.number && valueToTest && options.min > +valueToTest) {
      newErrors.push(options.customMessage || "Not enough, min " + options.min);
    }

    if (options.maxChar && valueToTest && valueToTest.length > options.maxChar) {
      newErrors.push("Please type at most " + options.maxChar + " characters");
    }

    if (options.atLeast && valueToTest && valueToTest.length < options.atLeast) {
      newErrors.push("Please choose at least " + options.atLeast + " options");
    }

    if (options.atMost && valueToTest && valueToTest.length > options.atMost) {
      newErrors.push("Please choose at most " + options.atMost + " options");
    }

    if (options.tel && valueToTest && valueToTest.length < 10) {
      newErrors.push("Please enter a valid phone number. " + (10 - valueToTest.length) + " numbers left");
    }

    if (options.customValidation && valueToTest && !validCustom(valueToTest, options.customValidation)) {
      newErrors.push(options.customMessage || 'This field does not match expectations');
    }

    if (!(options.date && newErrors.length)) {
      setValue(valueToTest);
    }

    setErrors(newErrors);
  };

  var handleDateChange = function handleDateChange(date) {
    return checkErrors(date);
  };

  var handleChangeRadioGroup = function handleChangeRadioGroup(id, RadioGroupOptions) {
    var radioChecked = RadioGroupOptions.filter(function (radio) {
      return id === radio.id;
    });
    checkErrors(radioChecked.length ? radioChecked[0].value : undefined);
  };

  var handleChangeCheckboxGroup = function handleChangeCheckboxGroup(CheckboxGroupChecked) {
    return checkErrors(CheckboxGroupChecked);
  };

  var handleValueChange = function handleValueChange(event) {
    return checkErrors(event && typeof event === 'object' ? event.target.value : event);
  };

  var handleSelectChange = function handleSelectChange(object) {
    return checkErrors(object);
  };

  var handleCheck = function handleCheck(event) {
    event.persist();
    checkErrors(event.target.checked);
  }; // const handleEventCheck = event => {
  //     event.persist();
  //     checkErrors(event.target.checked);
  // };
  // const handleEventValue = event => {
  //     event.persist();
  //     checkErrors(event.target.checked);
  // };
  // const handleValue = value => checkErrors(value);


  var handleInput = function handleInput(event) {
    return errors.length && checkErrors(event.target.value);
  };

  return [initialValue, errors, {
    onChange: handleValueChange,
    onInput: handleInput,
    onClick: handleCheck,
    onSelect: handleSelectChange,
    onBlur: handleValueChange,
    onChangeCheckbox: handleCheck,
    onChangeCheckboxGroup: handleChangeCheckboxGroup,
    onChangeRadio: handleCheck,
    onChangeRadioGroup: handleChangeRadioGroup,
    onChangeDate: handleDateChange
  }];
};

var _default = useFormElementValidation;
exports.default = _default;